module.exports = __webpack_public_path__ + "img/政策法规.b61f973a.png";